module.exports = __webpack_public_path__ + "static/image1-39dcfef82ecbb08ebaded4ef811a6c12.jpg";